import {get} from "lodash"
import BaseService from "./Base"
import {
    SalesforceUnreadCounterSettingsListRequest,
    SalesforceUnreadCounterSettingsResponse,
    SalesforceUnreadCounterSettingsUpdateRequest
} from "types/integrations/salesforceUnreadCounterSettings"

class SalesforceIntegrationService extends BaseService {
    async listUnreadCounterSettings(
        params: SalesforceUnreadCounterSettingsListRequest = {}
    ): Promise<SalesforceUnreadCounterSettingsResponse> {
        const response = await this.post(
            "/v1/integrations/salesforce/department-role-unread-counter-settings/list",
            params
        )
        return get(response, "data", {success: false, data: {settings: []}})
    }

    async updateUnreadCounterSettings(
        payload: SalesforceUnreadCounterSettingsUpdateRequest
    ): Promise<SalesforceUnreadCounterSettingsResponse> {
        const response = await this.post(
            "/v1/integrations/salesforce/department-role-unread-counter-settings/update",
            payload
        )
        return get(response, "data", {success: false, data: {settings: []}})
    }
}

export default SalesforceIntegrationService
